export const selectCategory = (state) => state.merchantCategories.category;
